import { Component, OnInit } from '@angular/core';
import { DiseasesVaccinesService } from './diseases-vaccines.service';
import { DiseaseVaccineModel } from '../../../models/master-data/diseases-vaccines.model';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { Utility } from '../../../common/utility';
import { DialogService } from '../../../shared/services/dialog.service';
import { AddNewDiseaseVaccineComponent } from './add-new-disease-vaccine.component';
import { FormGroup } from '@angular/forms';
import { DiseasesModel } from '../../../models/master-data/diseases.model';
import { TMBDataTableComponent } from '../../../components/data-table/data-table.component';
import { SharedService } from '../../../shared/services/share.services';
import { RowHeightCache } from '@swimlane/ngx-datatable/release/utils';

@Component({
    selector: 'diseases-vaccines-list',
    templateUrl: 'diseases-vaccines-list.component.html',
    providers: [DiseasesVaccinesService]
})

export class DiseasesVaccinesListComponent extends TMBDataTableComponent implements OnInit {
    dataRow = new Array<DiseaseVaccineModel>();
    diseaseVaccineList: FormGroup;
    public filterData = { diseaseId: null, diseaseName :'', vaccineName: '', isDefault: false};
    public diseases = new Array<DiseasesModel>();

    constructor(public sharedService: SharedService,
        public dialogService: DialogService,
        public utility: Utility,
        private diseasesVaccinesService: DiseasesVaccinesService) {
            super(sharedService);
         }

    ngOnInit() {
        this.diseasesVaccinesService.getDiseaseList().subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.diseases = data['list'].filter(dis => dis.isHaveVaccine == true);
                    // set default filter is first element list
                    if (this.diseases.length > 0) {
                        this.filterData.diseaseId = this.diseases[0].id;
                        this.filterData.diseaseName = this.diseases[0].name;
                        this.setPage({ offset: 0 });
                    }
                }
            }
        );
    }

    setPage(pageInfo) {
        this.page.pageNumber = pageInfo.offset;
        const param = {
            selectDisease: this.filterData.diseaseId === 'null' ? '' : this.filterData.diseaseId,
            pageSize: this.page.size,
            currentPage: this.page.pageNumber + 1,
            vaccineName: this.filterData.vaccineName
        };

        this.diseasesVaccinesService.getVaccinesList(param).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.dataRow = data['list'];
                    this.page.pageNumber = pageInfo.offset;
                    this.page.totalElements = data['totalRecords'];
                }
            },
            error => { }
        );
    }

    onFilter() {
        this.setPage({ offset: 0 });
    }

    onRemoveItem(id) {
      if(this.dataRow.length == 1)
      {
        this.dialogService.openConfirmationDialog({message:"This is default vaccine, Do you want to remove it?"}).subscribe(
          (result) => {
              if (result) {
                  this.diseasesVaccinesService.removeVaccine(id).subscribe(
                    deleteResult => {
                      if (deleteResult) {
                        this.reloadPage(this.page.pageNumber, this.dataRow, true);
                      }
                    }
                  );
              }
          });
      }
      else
      {
        this.dialogService.openConfirmationDialog({ message: AppMessages.diseasesVaccine.removeDiseasesVaccine }).subscribe(
          (result) => {
              if (result) {
                  this.diseasesVaccinesService.removeVaccine(id).subscribe(
                    deleteResult => {
                      if (deleteResult) {
                        this.reloadPage(this.page.pageNumber, this.dataRow, true);
                      }
                    }
                  );
              }
          });
      }
    }

    updateDefaultVaccine(event, id, name)
    {
      event.preventDefault();
      this.dialogService.openConfirmationDialog({message: "Are you sure you want to mark " + name +" as default?"}).subscribe(
        (result) => {
            if (result) {
              this.diseasesVaccinesService.updateVaccine(id).subscribe(
                updateResult => {
                  if (updateResult) {
                    this.reloadPage(this.page.pageNumber, this.dataRow, true);
                  }
                }
              );
            }
        });

    }

    addNewDiseaseVaccine(): void {
        const data = {
            diseaseId: this.filterData.diseaseId,
            diseaseName: this.filterData.diseaseName,
            dataList: this.dataRow
        };
        this.dialogService.openComponentDialog(AddNewDiseaseVaccineComponent,
              data,
            { width: '700px' }).subscribe(
                result => {
                    if (result) {
                      this.reloadPage(this.page.pageNumber, this.dataRow);
                    }
                }
            );
    }

    onDiseaseChange() {
        this.filterData.vaccineName = '';
        this.diseases.forEach(item => {
            if (item.id === this.filterData.diseaseId) {
                this.filterData.diseaseName = item.name;
            }
        });
        this.setPage({ offset: 0 })
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/diseases-vaccines/diseases-vaccines-list.component.ts